import { render, staticRenderFns } from "./VLink.vue?vue&type=template&id=26bc3a85&"
import script from "./VLink.vue?vue&type=script&lang=js&"
export * from "./VLink.vue?vue&type=script&lang=js&"
import style0 from "./VLink.vue?vue&type=style&index=0&id=26bc3a85&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports